import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.array.sort";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Vue from 'vue';
import uploader from "lib/mixins/uploader";
import PreparingCourseware from "components/PreparingCourseware.vue";
export default {
  name: "oss-question-file",
  components: {
    // SourcePreview,
    PreparingCourseware: PreparingCourseware
  },
  mixins: [uploader],
  props: {
    fileIds: {
      type: Array,
      default: ""
    },
    filesList: {
      type: Array,
      default: {
        Id: String,
        DocTitle: String,
        DocUrl: String,
        DocPrviewUrl: String
      }
    },
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.filesList.sort();
  },
  computed: {
    auth: function auth() {
      var auth = this.$store.state.auth;
      return _objectSpread({}, auth);
    }
  },
  data: function data() {
    return {
      docId: "",
      questionFiles: [],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      removeids: [],
      dialogVisiblePreviewResources: false,
      IsShowUpload: false,
      // defaultCover: require("assets/images/noCover.jpg"),
      // xlsCover: require("assets/images/xls.png"),
      // // swfCover: require("assets/images/swf.png"),
      // // mp3Cover: require("assets/images/mp3.png"),
      // zipCover: require("assets/images/zip.png"),
      isShow: true
    };
  },
  watch: {
    filesList: function filesList(val) {
      var _this = this;

      this.questionFiles = [];
      this.removeids = [];
      var url = "";
      val.forEach(function (element) {
        // url = element.DocUrl==""?this.defaultCover:element.DocUrl;
        if (element.DocExtension === ".pdf" || element.DocExtension === ".txt" || element.DocExtension === ".ppt" || element.DocExtension === ".pptx" || element.DocExtension === ".doc" || element.DocExtension === ".docx") {
          url = element.DocPrexUrl === "" ? _this.defaultCover : element.DocPrexUrl;
        } else if (element.DocExtension === ".mp4") {
          url = element.DocUrl === "" ? _this.defaultCover : element.DocUrl + "?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160";
        } else if (element.DocExtension === ".ziph") {
          url = _this.defaultCover;
        } else if (element.DocExtension === ".xlsx" || element.DocExtension === ".xls") {
          url = _this.xlsCover;
        } else if (element.DocExtension === ".swf") {
          url = _this.swfCover;
        } else if (element.DocExtension === ".mp3") {
          url = _this.mp3Cover;
        } else if (element.DocExtension === ".rar" || element.DocExtension === ".zip" || element.DocExtension === ".7z") {
          url = _this.zipCover;
        } else {
          url = element.DocUrl === "" ? _this.defaultCover : element.DocUrl;
        }

        _this.questionFiles.push({
          name: element.DocTitle,
          url: url,
          docId: element.Id
        });

        _this.removeids.push(element.Id);
      });
      this.$emit("update:fileIds", this.removeids);
    },
    dialogVisiblePreviewResources: function dialogVisiblePreviewResources(val) {
      this.$emit("Preview", val);
    }
  },
  methods: {
    uploadFile: function uploadFile() {},
    dialogClose: function dialogClose() {
      this.IsShowUpload = false;
      this.dialogVisiblePreviewResources = false;
    },
    beforeUpload: function beforeUpload(file) {
      this.IsShowUpload = true;
      return this.addFile(file);
    },
    onRemoveHandler: function onRemoveHandler(file) {
      // if (this.onRemove) {
      //   this.onRemove();
      // }
      this.questionFiles = this.questionFiles.filter(function (p) {
        return p.docId !== file.docId;
      });
      this.removeids.splice(this.removeids.indexOf(file.docId), 1);
      this.removeids = this.removeids.filter(function (p) {
        return p !== file.docId;
      });
      this.$emit("update:fileIds", this.removeids);
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    handlePreview: function handlePreview(file) {
      this.dialogVisiblePreviewResources = true;
      this.docId = file.docId; // GetFileInfo(file.docId).then(rst => {
      //   if (rst.status == -1) {
      //     this.$message.warning("文件转换失败不能预览");
      //   } else if (rst.status == -2) {
      //     this.$message.warning("文件正在转换请稍后预览");
      //   } else if (rst.status == 1) {
      //     this.sourceUrl = {
      //       url: rst.docPriviewUrl,
      //       type: rst.type,
      //       docName: rst.docName,
      //       docType: rst.docType,
      //       id:file.docId
      //     };
      //   } else {
      //     this.$message.warning(rst.msg);
      //   }
      // });
    },
    onSuccessHandler: function onSuccessHandler(res, file, uploadFiles) {
      var _this2 = this;

      var that = this;
      this.IsShowUpload = false;
      var IsUpdate = false;

      for (var i = 0; i < uploadFiles.length - 1; i++) {
        if (uploadFiles[i].url.replace("http://file.chinahoteledu.com", "") == res.docPath.replace("http://file.chinahoteledu.com", "")) {
          IsUpdate = true;
        }
      }

      if (IsUpdate) {
        uploadFiles.splice(uploadFiles.length - 1, 1);
      } // 执行mixins里的onSuccess, 继续下一个文件


      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }

      if (res.code > 0) {
        file.url = res.docPath;
      }

      this.$http.post('/api/XOrg/BookMaterial/getDocUrl', {
        Id: file.response.docId
      }).then(function (rst) {
        if (rst.code === 1) {
          var url = "";

          if (rst.courseWare.DocExtension === ".pdf" || rst.courseWare.DocExtension === ".txt" || rst.courseWare.DocExtension === ".ppt" || rst.courseWare.DocExtension === ".pptx" || rst.courseWare.DocExtension === ".doc" || rst.courseWare.DocExtension === ".docx") {
            url = rst.courseWare.DocPrexUrl === "" ? _this2.defaultCover : rst.courseWare.DocPrexUrl;
          } else if (rst.courseWare.DocExtension === ".mp4") {
            url = rst.courseWare.DocUrl === "" ? _this2.defaultCover : rst.courseWare.DocUrl + "?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160";
          } else if (rst.courseWare.DocExtension === ".ziph") {
            url = _this2.defaultCover;
          } else if (rst.courseWare.DocExtension === ".xlsx" || rst.courseWare.DocExtension === ".xls") {
            url = _this2.xlsCover;
          } else if (rst.courseWare.DocExtension === ".swf") {
            url = _this2.swfCover;
          } else if (rst.courseWare.DocExtension === ".mp3") {
            url = _this2.mp3Cover;
          } else if (rst.courseWare.DocExtension === ".rar" || rst.courseWare.DocExtension === ".zip" || rst.courseWare.DocExtension === ".7z") {
            url = _this2.zipCover;
          } else {
            url = rst.courseWare.DocUrl === "" ? _this2.defaultCover : rst.courseWare.DocUrl;
          }

          if (!IsUpdate) {
            that.questionFiles.push({
              name: file.name,
              url: url,
              docId: res.docId
            });

            _this2.removeids.push(res.docId);
          } else {
            _this2.$message.error("不能上传相同文件!");
          }
        } else {
          _this2.questionFiles.push({
            name: file.name,
            url: res.docPath,
            docId: res.docId
          });

          _this2.removeids.push(res.docId);
        }
      }); // this.questionFiles.push({
      //   name: file.name,
      //   url: res.docPath,
      //   docId: res.docId
      // });

      this.$emit("update:fileIds", this.removeids);
    }
  }
};